// removed by extract-text-webpack-plugin
module.exports = {"Landing":"Landing__Landing___t1QSj","Table":"Landing__Table___1nejT"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Landing/Landing.scss
// module id = 236
// module chunks = 0